/**
 * Allow animation to height:auto
 *
 * Useful e.g. for accordions: this measures an element's
 * height, then adds a --h-auto variable to that element's
 * parent. That way, you can animate to --h-auto rather than
 * height:auto (which doesn't work). Applying height to the parent
 * rather than the element itself ensures padding also gets collapsed
 *
 * @param {string} selector Selector to measure (applies style to parent)
 */

// import dependencies
import debounce from './debounce'

// set up functionality
export const setupAutoHeightAni = (selector) => {
	// get all the auto height elements
	const els = document.querySelectorAll(selector)
	// if we have some elements
	if (els.length) {
		// handle setting height to auto then resetting to actual calculated height on parent
		const setHeights = () => {
			els.forEach((el) => {
				el.parentElement.style.setProperty('--h-auto', `auto`)
				el.parentElement.style.setProperty('--h-auto', `${el.offsetHeight}px`)
			})
		}
		// set heights right away
		setHeights()
		// on load reset heights (useful for slow-loading assets like video)
		window.addEventListener('load', debounce(setHeights, 100))
		// on resize wait a moment (for performance) then reset heights
		window.addEventListener('resize', debounce(setHeights, 100))
	}
}
